module.exports = __webpack_public_path__ + "img/selected0-min.dcae35ee.png";